import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DataService } from '../services/DataService';
import Datalist, { ListColumn } from '../components/Datalist/Datalist';
import { Button, Stack } from 'react-bootstrap';
import { SearchBar } from '../components/SearchBar/SearchBar';
import { TGroup } from '../services/API/Groups';
import { TSupplier } from '../services/API/Suppliers';
import { IsUserSinfra } from '../lib/utils';
import StyledCheckbox from '../components/StyledCheckbox/StyledCheckbox';
import { faFilterCircleXmark, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SupplierFilter } from '../components/ReportsFilter/SupplierFilter';

interface Props extends WithTranslation {

}
type FilterKeys = 'active' | 'inactive' | 'all'
interface State {
  isLoading: boolean;
  //suppliers: TSupplier[];
  //activeSuppliers: TSupplier[];
  columns: ListColumn<TSupplier>[];
  searchText:string;
  test:any[]
 // onlyShowActive:boolean;
  isFilterActive:boolean;
  showFilter:boolean;
  filter:{
    active:boolean;
    inactive:boolean;
    all:boolean;
  }
  filterKey:FilterKeys
}

class SupplierManagementPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    
    this.state = {
      isLoading: true,
      //suppliers:[],
      //activeSuppliers: [],
      columns: this.columns,
      searchText: "",
      test:[],
     // onlyShowActive: false,
      isFilterActive:false,
      showFilter:false,
      filter:{
        active:true,
        inactive:false,
        all:false
      },
      filterKey:'active'
    }

  }

  async componentDidMount(): Promise<void> {
    
    if(!IsUserSinfra())
      window.location.href = "/"
    const [/*activeSuppliers, suppliers,*/test] = await Promise.all([
      //DataService.Suppliers.Get(true),
      //DataService.Suppliers.Get(),
      DataService.Suppliers.GetSuppliersForFilter()
    ]);
    this.setState({
      isLoading: false,
      //suppliers: suppliers,
      //activeSuppliers,
      test
    }/*,() => console.log(test)*/);
  }

  private columns : ListColumn<any>[] = [
    {
      name: this.props.t("general.supplierName"),
      fieldName: "supplierName",
      key: "supplierName",
      minWidth: 100,
      isActive: true,
      sorting: true,
      onRender: (item,col,index) => {
        return <p style={{position:'inherit',margin:0,padding:0}}>{item.supplierName}</p>
      }
    },
    {
      name: this.props.t("general.supplierOrgId"),
      fieldName: "supplierOrgId",
      key: "supplierOrgId",
      minWidth: 100,
      isActive: true,
      sorting: true
    }
  ]
  onChangeFilter = (key:FilterKeys, value:boolean) => {
    console.log('OnChangeFilter', key, value);

  const newFilter = {
    active: false,
    inactive: false,
    all: false,
  };

  if (this.state.filter[key]) {
    // Om den redan är true och togglas av
    // Kolla om vi måste återställa till all=true
    const allOthersFalse = Object.entries(this.state.filter)
      .filter(([k]) => k !== key)
      .every(([, v]) => !v);

    if (allOthersFalse) {
      newFilter.all = true;
    }
  } else {
    // Om vi sätter en ny till true
    newFilter[key] = true;
  }

  this.setState({ filterKey: key, filter: newFilter });
  }
  render() {
    const currentList = this.state.filterKey == 'all' ? this.state.test : this.state.filterKey == 'active' ? this.state.test.filter(filter => filter.supplierActive) :this.state.test.filter(filter => !filter.supplierActive) /*(this.state.filterKey == 'all' ) ? this.state.activeSuppliers : this.state.suppliers;*/
  
    const suppliers = currentList.filter(supp => {
      const onSearch = this.state.searchText.length > 0 ?
        supp.supplierName.toLowerCase().includes(this.state.searchText.toLowerCase()) 
          || supp.supplierOrgId.toLowerCase().includes(this.state.searchText.toLowerCase())
        : true;
      return onSearch;
     
    });
   suppliers.push({supplierName:'',supplierOrgId:''});
    return (
      <Stack gap={4}>
        <div>
          <h2>{this.props.t('supplierManagement.title')}</h2>
          {/* <p>{this.props.t('supplierManagement.description')}</p> */}
        </div>
        <div className='list-toolbar'>
          <SearchBar
            onChange={(newVal) => { this.setState({ searchText: newVal }) }}
            value={this.state.searchText}
            placeholder={this.props.t("supplierManagement.searchPlaceholder").toString()}
          />
          <Button
                  className="button-cancel"
                  onClick={() => {
                    this.setState({ showFilter: !this.state.showFilter });
                  }}
                >
          <FontAwesomeIcon
                              icon={
                                this.state.isFilterActive ? faFilterCircleXmark : faFilter
                              }
                            />
          </Button>                  
          {/* <StyledCheckbox 
            isChecked={this.state.onlyShowActive} 
            label={this.props.t('supplierManagement.onlyActive')} 
            onChange={(newVal: boolean) => {
              this.setState({ onlyShowActive: newVal });
            }} 
          /> */}
        </div>
        <SupplierFilter onChange={this.onChangeFilter} isOpen={this.state.showFilter} title='Filtrera leverantörer'  filter={this.state.filter}/>
        <div className="testForViewTable" style={{height: "50vh"}}>
          <Datalist 
            uniqueKey='id'
            items={suppliers} 
            columns={this.state.columns} 
            setColumns={(cols) => this.setState({columns: cols})} 
            noItemsText={this.props.t("supplierManagement.noItemsInTable")} 
            initialSortKey='supplierName'
            onClick={(supplier) => { window.location.href = `/editSupplier/${supplier.supplierOrgId}` }}
            isLoading={this.state.isLoading}
          />
        </div>
      </Stack>
   );
  }
 
};

export default withTranslation()(SupplierManagementPage);